import { useMemo } from 'react';
import { Link } from 'react-router-dom';

import { Button } from 'twyne-new.ui';

import { useGrid } from '@Components/Grid/context';

export default function AddButton() {
  const { definitions: { entityNameModule, entityNamePlural, entityName, basePath } } = useGrid()

  const path = useMemo(() => basePath || `/${entityNameModule}/${entityNamePlural.toLowerCase()}`, [basePath, entityNamePlural, entityNameModule])

  return <Button color='accent' size='lg' asChild>
    <Link to={`${path}/add`}>
      Add {entityName}
    </Link>
  </Button>
}
